import api from './api';

export const getBiddingItems = async () => {
  const response = await api.get('/bidding/items');
  return response.data;
};

export const createBiddingItem = async (data) => {
  const response = await api.post('/bidding/items', data);
  return response.data;
};

export const updateBiddingItem = async (id, data) => {
  const response = await api.put(`/bidding/items/${id}`, data);
  return response.data;
};

export const uploadBiddingPhoto = async (itemId, file) => {
  const formData = new FormData();
  formData.append('photo', file);
  const response = await api.post(`/bidding/items/${itemId}/photos`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const deleteBiddingPhoto = async (photoId) => {
  const response = await api.delete(`/bidding/photos/${photoId}`);
  return response.data;
};

export const placeBid = async (data) => {
  const response = await api.post('/bidding/bid', data);
  return response.data;
};

export const verifyBidOtp = async (data) => {
  const response = await api.post('/bidding/verify-otp', data);
  return response.data;
};

export const getBiddingCategories = async () => {
  const response = await api.get('/bidding/categories');
  return response.data;
};

export const createBiddingCategory = async (data) => {
  const response = await api.post('/bidding/categories', data);
  return response.data;
};

export const getAllBids = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.item_id) params.append('item_id', filters.item_id);
  if (filters.user_id) params.append('user_id', filters.user_id);
  if (filters.status) params.append('status', filters.status);
  if (filters.date_from) params.append('date_from', filters.date_from);
  if (filters.date_to) params.append('date_to', filters.date_to);
  
  const response = await api.get(`/bidding/bids?${params.toString()}`);
  return response.data;
};

export const exportBids = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.item_id) params.append('item_id', filters.item_id);
  if (filters.status) params.append('status', filters.status);
  if (filters.date_from) params.append('date_from', filters.date_from);
  if (filters.date_to) params.append('date_to', filters.date_to);
  params.append('export', 'csv');
  
  const response = await api.get(`/bidding/bids?${params.toString()}`, {
    responseType: 'blob'
  });
  return response.data;
};

/**
 * Get admin items with winner status
 */
export const getAdminItems = async () => {
  const response = await api.get('/bidding/items/admin');
  return response.data;
};

/**
 * Export bidding items to CSV
 */
export const exportBiddingItems = async () => {
  const response = await api.get('/bidding/items/export', {
    responseType: 'blob'
  });
  return response.data;
};

/**
 * Close an auction manually
 */
export const closeAuction = async (itemId) => {
  const response = await api.post(`/bidding/items/${itemId}/close`);
  return response.data;
};

/**
 * Verify winner OTP to reveal bidder details
 */
export const verifyWinnerOtp = async (itemId, otp) => {
  const response = await api.post('/bidding/verify-winner', { item_id: itemId, otp });
  return response.data;
};

/**
 * Get anonymous bids (no personal details)
 */
export const getAnonymousBids = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.item_id) params.append('item_id', filters.item_id);
  if (filters.status) params.append('status', filters.status);
  if (filters.date_from) params.append('date_from', filters.date_from);
  if (filters.date_to) params.append('date_to', filters.date_to);
  params.append('anonymous', '1');
  
  const response = await api.get(`/bidding/bids?${params.toString()}`);
  return response.data;
};

/**
 * Approve a bid item for external bidding
 */
export const approveBidItem = async (itemId) => {
  const response = await api.post(`/bidding/items/${itemId}/approve`);
  return response.data;
};
